<template>
	<div class="sleepingarea" ref="main_wrapper" v-parallax-fit="parallax">
		<img class="bg-1" src="/themes/rise-theme/dist/images/estate/character-view/ozzie/11_Neighborhood_Greyscale@2x.png" alt="">
		<img class="bg-2" v-parallax-fit="bg_2" src="/themes/rise-theme/dist/images/estate/character-view/ozzie/12_Neighborhood_Sepia@2x.png" alt="">
		<img ref="bg_3" class="bg-3" v-parallax-fit="bg_3" src="/themes/rise-theme/dist/images/estate/character-view/ozzie/13_Neighborhood_color@2x.png" alt="">

		<div v-parallax-fit="marker_1" class="marker marker-1">
			<img src="/themes/rise-theme/dist/images/estate/character-view/ozzie/14_LocationMarker_Single@2x.png" alt="">
		</div>
		<div v-parallax-fit="marker_1" class="marker marker-2">
			<img src="/themes/rise-theme/dist/images/estate/character-view/ozzie/14_LocationMarker_Single@2x.png" alt="">
		</div>
		<div v-parallax-fit="marker_1" class="marker marker-3">
			<img src="/themes/rise-theme/dist/images/estate/character-view/ozzie/14_LocationMarker_Single@2x.png" alt="">
		</div>
		<div v-parallax-fit="marker_2" class="marker marker-4">
			<img src="/themes/rise-theme/dist/images/estate/character-view/ozzie/14_LocationMarker_Single@2x.png" alt="">
		</div>
		<div v-parallax-fit="marker_2" class="marker marker-5">
			<img src="/themes/rise-theme/dist/images/estate/character-view/ozzie/14_LocationMarker_Single@2x.png" alt="">
		</div>
		<div v-parallax-fit="marker_2" class="marker marker-6">
			<img src="/themes/rise-theme/dist/images/estate/character-view/ozzie/14_LocationMarker_Single@2x.png" alt="">
		</div>
		<div v-parallax-fit="marker_3" class="marker marker-7">
			<img src="/themes/rise-theme/dist/images/estate/character-view/ozzie/14_LocationMarker_Single@2x.png" alt="">
		</div>
		<div v-parallax-fit="marker_3" class="marker marker-8">
			<img src="/themes/rise-theme/dist/images/estate/character-view/ozzie/14_LocationMarker_Single@2x.png" alt="">
		</div>
		<div v-parallax-fit="marker_3" class="marker marker-9">
			<img src="/themes/rise-theme/dist/images/estate/character-view/ozzie/14_LocationMarker_Single@2x.png" alt="">
		</div>
		<div v-parallax-fit="marker_4" class="marker marker-10">
			<img src="/themes/rise-theme/dist/images/estate/character-view/ozzie/14_LocationMarker_Single@2x.png" alt="">
		</div>
		<div v-parallax-fit="marker_4" class="marker marker-11">
			<img src="/themes/rise-theme/dist/images/estate/character-view/ozzie/14_LocationMarker_Single@2x.png" alt="">
		</div>
		<div v-parallax-fit="marker_4" class="marker marker-12">
			<img src="/themes/rise-theme/dist/images/estate/character-view/ozzie/14_LocationMarker_Single@2x.png" alt="">
		</div>
		<div v-parallax-fit="marker_5" ref="marker_5" class="marker marker-13">
			<img src="/themes/rise-theme/dist/images/estate/character-view/ozzie/14_LocationMarker_Single@2x.png" alt="">
		</div>
		<div v-parallax-fit="marker_5" class="marker marker-14">
			<img src="/themes/rise-theme/dist/images/estate/character-view/ozzie/14_LocationMarker_Single@2x.png" alt="">
		</div>
		<div v-parallax-fit="marker_5" class="marker marker-15">
			<img src="/themes/rise-theme/dist/images/estate/character-view/ozzie/14_LocationMarker_Single@2x.png" alt="">
		</div>
		<div v-parallax-fit="marker_6" class="marker marker-16">
			<img src="/themes/rise-theme/dist/images/estate/character-view/ozzie/14_LocationMarker_Single@2x.png" alt="">
		</div>
		<div v-parallax-fit="marker_6" class="marker marker-17">
			<img src="/themes/rise-theme/dist/images/estate/character-view/ozzie/14_LocationMarker_Single@2x.png" alt="">
		</div>
		<div v-parallax-fit="marker_6" class="marker marker-18">
			<img src="/themes/rise-theme/dist/images/estate/character-view/ozzie/14_LocationMarker_Single@2x.png" alt="">
		</div>
		<div v-parallax-fit="marker_7" class="marker marker-19">
			<img src="/themes/rise-theme/dist/images/estate/character-view/ozzie/14_LocationMarker_Single@2x.png" alt="">
		</div>
		<div v-parallax-fit="marker_7" class="marker marker-20">
			<img src="/themes/rise-theme/dist/images/estate/character-view/ozzie/14_LocationMarker_Single@2x.png" alt="">
		</div>
		<div v-parallax-fit="marker_7" class="marker marker-21">
			<img src="/themes/rise-theme/dist/images/estate/character-view/ozzie/14_LocationMarker_Single@2x.png" alt="">
		</div>
		<div v-parallax-fit="marker_8" class="marker marker-22">
			<img src="/themes/rise-theme/dist/images/estate/character-view/ozzie/14_LocationMarker_Single@2x.png" alt="">
		</div>
		<div v-parallax-fit="marker_8" class="marker marker-23">
			<img src="/themes/rise-theme/dist/images/estate/character-view/ozzie/14_LocationMarker_Single@2x.png" alt="">
		</div>
		<div v-parallax-fit="marker_8" class="marker marker-24">
			<img src="/themes/rise-theme/dist/images/estate/character-view/ozzie/14_LocationMarker_Single@2x.png" alt="">
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				mutationObserver: null,
				parallax: [
					{
						start: 12000,
						end: 15000,
						fromStyle: { transform: 'translateY(-500%) rotate(0deg)' },
           				toStyle: { transform: 'translateY(0%) rotate(0deg)' },
						easing: 'linear'
					},
					{
						start: 19000,
						end: 21000,
						fromStyle: { transform: 'translateY(0%) rotate(0deg)' },
           				toStyle: { transform: 'translateY(500%) rotate(45deg)' },
						easing: 'linear'
					}
				],
				marker_1: [
					{
						start: 15000,
						end: 15500,
						fromStyle: { transform: 'scale(0)' },
           				toStyle: { transform: 'scale(1)' },
						easing: 'linear'
					}
				],
				marker_2: [
					{
						start: 15500,
						end: 16000,
						fromStyle: { transform: 'scale(0)' },
           				toStyle: { transform: 'scale(1)' },
						easing: 'linear'
					}
				],
				marker_3: [
					{
						start: 16000,
						end: 16500,
						fromStyle: { transform: 'scale(0)' },
           				toStyle: { transform: 'scale(1)' },
						easing: 'linear'
					}
				],
				marker_4: [
					{
						start: 16500,
						end: 17000,
						fromStyle: { transform: 'scale(0)' },
           				toStyle: { transform: 'scale(1)' },
						easing: 'linear'
					}
				],
				marker_5: [
					{
						start: 17000,
						end: 17500,
						fromStyle: { transform: 'scale(0)' },
           				toStyle: { transform: 'scale(1)' },
						easing: 'linear'
					}
				],
				marker_6: [
					{
						start: 17500,
						end: 18000,
						fromStyle: { transform: 'scale(0)' },
           				toStyle: { transform: 'scale(1)' },
						easing: 'linear'
					}
				],
				marker_7: [
					{
						start: 18000,
						end: 18500,
						fromStyle: { transform: 'scale(0)' },
           				toStyle: { transform: 'scale(1)' },
						easing: 'linear'
					}
				],
				marker_8: [
					{
						start: 18500,
						end: 19000,
						fromStyle: { transform: 'scale(0)' },
           				toStyle: { transform: 'scale(1)' },
						easing: 'linear'
					}
				],
				bg_2: [
					{
						start: 15000,
						end: 15300,
						fromStyle: { opacity: 0 },
           				toStyle: { opacity: 1 },
						easing: 'linear'
					}
				],
				bg_3: [
					{
						start: 16700,
						end: 17000,
						fromStyle: { opacity: 0 },
           				toStyle: { opacity: 1 },
						easing: 'linear'
					}
				]
			}
		},
		mounted() {
			const self = this;
    		const evidence = {
			    items: [
			        {
			        	image: '/themes/rise-theme/dist/images/estate/character-view/ozzie/evidence/2.png',
			          	url: 'https://www.mainstreet.org/blogs/national-main-street-center/2020/10/15/community-spotlight-mexicantown-detroit-michigan',
			          	link_title: {
							'en': "Community Spotlight: Mexicantown in Detroit, Michigan",
							'es': 'Destacado de la comunidad: Mexicantown en Detroit, Michigan'
						},
			        }
			    ],
			    text: {
					'en': 'The Mexican community has been steadily growing and is considered one of Detroit’s most treasured neighborhoods. Its abundant diversity, walkability, and thriving business district has long been a magnet for newcomers.',
					'es': 'La comunidad mexicana ha ido creciendo constantemente y se considera uno de los barrios más preciados de Detroit. Su abundante diversidad, accesibilidad para peatones y próspero distrito comercial ha sido durante mucho tiempo un imán para los recién llegados.'
				}
		    };

		    const text = {
				'en': "Southwest Detroit, known as Mexicantown, is one of Detroit's most colorful communities. Even though this part of the city only emcompasses 1.365 miles, Mexicantown is filled with beautiful murals, bakeries, and restaurants that speak to the neighborhood's diversity and the history of the residents who lived there.",
				'es': 'El suroeste de Detroit, conocido como Mexicantown, es una de las comunidades más coloridas de Detroit. Aunque esta parte de la ciudad solo abarca 1.365 millas, Mexicantown está lleno de hermosos murales, panaderías y restaurantes que hablan de la diversidad del vecindario y la historia de los residentes que vivieron allí.'
			};

    		this.mutationObserver = new window.MutationObserver(mutationList => {
			    mutationList.forEach(mutation => {
			        if (mutation.target.style.transform == 'translateY(0%) rotate(0deg)') {
			        	this.$evidence.value = JSON.stringify(evidence);
		    			this.$readMore.value = text;
			        }
			    });
		    });

		    this.mutationObserver.observe(this.$refs.main_wrapper, {
		    	attributes: true,
		    	attributeFilter: ['style']
		    });
		},
		unmounted() {
		    this.mutationObserver.disconnect();
		}
	}
</script>

<style lang="scss" scoped>
	.sleepingarea {
		position: fixed;
		top: calc(50% - 350px);
		left: calc(50% - 430px);
		width: 950px;
		height: 700px;
		transition: all 0.1s linear;

		.bg-1, .bg-2, .bg-3 {
			position: absolute;
			top: 0;
			left: 0;
			z-index: 1;
			opacity: 0;
			display: block;
			width: 100%;
		}

		.bg-1 {opacity: 1;}

		.marker {
			position: absolute;
			left: 10%;
			bottom: 10%;
			width: 100px;
			z-index: 2;
			transition: all 0.1s linear;

			img {
				display: block;
				width: 100%;
			}

			&.marker:after,
			&.marker:before {
				opacity: 0;
				transition: all 0.1s 1s linear;
			}

			&.marker.show:after,
			&.marker.show:before {
				opacity: 1;
			}

			&.marker-1 {
				left: 41%;
				bottom: 28%;
				width: 100px;

				&:after {
					content: "";
					display: block;
					width: 2px;
					height: 130px;
					position: absolute;
					left: 50%;
					bottom: 50%;
					background: #e81f27;
					transform-origin: center;
					transform: rotate(-43deg) translate(-35px, -23px);
				}

				&:before {
					content: "";
					display: block;
					width: 167px;
					height: 2px;
					position: absolute;
					right: 50%;
					bottom: 50%;
					background: #e81f27;
					-webkit-transform-origin: center;
					transform-origin: center;
					transform: rotate(0deg) translate(3px, -9px);
				}
			}

			&.marker-2 {
				left: 25%;
			    bottom: 29%;
			    width: 85px;

			    &:after {
					content: "";
					display: block;
					width: 2px;
					height: 130px;
					position: absolute;
					left: 50%;
					bottom: 50%;
					background: #e81f27;
					transform-origin: center;
					transform: rotate(41deg) translate(36px, -23px);
				}

				&:before {
					content: "";
					display: block;
					width: 2px;
					height: 150px;
					position: absolute;
					left: 50%;
					bottom: 50%;
					background: #e81f27;
					transform-origin: center;
					transform: rotate(1deg) translate(1px, -9px);
				}
			}

			&.marker-3 {
				left: 16%;
				bottom: 37%;
				width: 65px;

				&:after {
					content: "";
					display: block;
					width: 105px;
					height: 2px;
					position: absolute;
					left: 50%;
					bottom: 50%;
					background: #e81f27;
					transform-origin: center;
					transform: rotate(25deg) translate(1px, 13px);
				}
			}

			&.marker-4 {
				left: 18%;
				bottom: 48%;
				width: 55px;

				&:after {
					content: "";
					display: block;
					width: 2px;
					height: 100px;
					position: absolute;
					left: 50%;
					bottom: 50%;
					background: #e81f27;
					transform-origin: center;
					transform: rotate(65deg) translate(38px, -31px);
				}

				&:before {
					content: "";
					display: block;
					width: 2px;
					height: 170px;
					position: absolute;
					left: 50%;
					bottom: 50%;
					background: #e81f27;
					transform-origin: center;
					transform: rotate(97deg) translate(77px, -94px);
				}
			}

			&.marker-5 {
				left: 28%;
			    bottom: 56%;
			    width: 35px;

			    &:after {
					content: "";
					display: block;
					width: 2px;
					height: 120px;
					position: absolute;
					left: 50%;
					bottom: 50%;
					background: #e81f27;
					transform-origin: center;
					transform: rotate(77deg) translate(56px, -54px);
				}

				&:before {
					content: "";
					display: block;
					width: 2px;
					height: 200px;
					position: absolute;
					left: 50%;
					bottom: 50%;
					background: #e81f27;
					transform-origin: center;
					transform: rotate(135deg) translate(71px, -170px);
				}
			}

			&.marker-6 {
				left: 36%;
			    bottom: 48%;
			    width: 35px;

			    &:after {
					content: "";
					display: block;
					width: 2px;
					height: 220px;
					position: absolute;
					left: 50%;
					bottom: 50%;
					background: #e81f27;
					transform-origin: center;
					transform: rotate(76deg) translate(102px, -81px);
				}

				&:before {
					content: "";
					display: block;
					width: 2px;
					height: 210px;
					position: absolute;
					left: 50%;
					bottom: 50%;
					background: #e81f27;
					transform-origin: center;
					transform: rotate(59deg) translate(85px, -50px);
				}
			}

			&.marker-7 {
				left: 55%;
				bottom: 42%;
				width: 70px;

				&:after {
					content: "";
					display: block;
					width: 2px;
					height: 220px;
					position: absolute;
					left: 50%;
					bottom: 50%;
					background: #e81f27;
					transform-origin: center;
					transform: rotate(80deg) translate(102px, -91px);
				}

				&:before {
					content: "";
					display: block;
					width: 2px;
					height: 139px;
					position: absolute;
					left: 50%;
					bottom: 50%;
					background: #e81f27;
					transform-origin: center;
					transform: rotate(57deg) translate(53px, 104px);
				}
			}

			&.marker-8 {
				left: 67%;
				bottom: 39%;
				width: 85px;

				&:after {
					content: "";
					display: block;
					width: 2px;
					height: 120px;
					position: absolute;
					left: 50%;
					bottom: 50%;
					background: #e81f27;
					transform-origin: center;
					transform: rotate(93deg) translate(49px, 59px);
				}
			}

			&.marker-9 {
				left: 78%;
			    bottom: 48%;
			    width: 65px;
			}

			&.marker-10 {
				left: 56%;
				bottom: 53%;
				width: 55px;

				&:after {
					content: "";
					display: block;
					width: 2px;
					height: 100px;
					position: absolute;
					left: 50%;
					bottom: 50%;
					background: #e81f27;
					transform-origin: center;
					transform: rotate(95deg) translate(44px, -52px);
				}

				&:before {
					content: "";
				    display: block;
				    width: 2px;
				    height: 71px;
				    position: absolute;
				    left: 50%;
				    bottom: 50%;
				    background: #e81f27;
					transform-origin: center;
					transform: rotate(181deg) translate(2px, -64px);
				}
			}

			&.marker-11 {
				left: 65%;
				bottom: 52%;
				width: 55px;

				&:after {
					content: "";
					display: block;
					width: 1.5px;
					height: 100px;
					position: absolute;
					left: 50%;
					bottom: 50%;
					background: #e81f27;
					transform-origin: center;
					transform: rotate(63deg) translate(40px, -29px);
				}

				&:before {
					content: "";
					display: block;
					width: 1.5px;
					height: 150px;
					position: absolute;
					left: 50%;
					bottom: 50%;
					background: #e81f27;
					transform-origin: center;
					transform: rotate(36deg) translate(40px, -18px);
				}
			}

			&.marker-12 {
				left: 75%;
			    bottom: 60%;
			    width: 40px;
			}

			&.marker-13 {
				left: 54%;
			    bottom: 63%;
			    width: 35px;

			    &:after {
					content: "";
					display: block;
					width: 1.5px;
					height: 130px;
					position: absolute;
					left: 50%;
					bottom: 50%;
					background: #e81f27;
					transform-origin: center;
					transform: rotate(51deg) translate(48px, -34px);
				}
			}

			&.marker-14 {
				left: 17%;
			    bottom: 65%;
			    width: 30px;

			    &:after {
					content: "";
				    display: block;
				    width: 1.5px;
				    height: 125px;
				    position: absolute;
				    left: 50%;
				    bottom: 50%;
				    background: #e81f27;
					transform-origin: center;
					transform: rotate(120deg) translate(52px, -92px);
				}
			}

			&.marker-15 {
				left: 42%;
			    bottom: 61%;
			    width: 30px;

			    &:after {
					content: "";
				    display: block;
				    width: 1.5px;
				    height: 85px;
				    position: absolute;
				    left: 50%;
				    bottom: 50%;
				    background: #e81f27;
					transform-origin: center;
					transform: rotate(51deg) translate(29px, -20px);
				}
			}

			&.marker-16 {
				left: 34%;
				bottom: 64%;
				width: 25px;

				&:after {
					content: "";
					display: block;
					width: 1.5px;
					height: 105px;
					position: absolute;
					left: 50%;
					bottom: 50%;
					background: #e81f27;
					transform-origin: center;
					transform: rotate(-11deg) translate(-9px, 104px);
				}
			}

			&.marker-17 {
				left: 26%;
				bottom: 70%;
				width: 25px;

				&:after {
					content: "";
				    display: block;
				    width: 1.5px;
				    height: 90px;
				    position: absolute;
				    left: 50%;
				    bottom: 50%;
				    background: #e81f27;
					transform-origin: center;
					transform: rotate(-61deg) translate(-37px, 64px);
				}
			}

			&.marker-18 {
				left: 41%;
			    bottom: 72%;
			    width: 25px;

			    &:after {
					content: "";
				    display: block;
				    width: 1.5px;
				    height: 85px;
				    position: absolute;
				    left: 50%;
				    bottom: 50%;
				    background: #e81f27;
					transform-origin: center;
					transform: rotate(50deg) translate(31px, 69px);
				}
			}

			&.marker-19 {
				left: 49%;
			    bottom: 70%;
			    width: 25px;

			    &:after {
					content: "";
				    display: block;
				    width: 1.5px;
				    height: 85px;
				    position: absolute;
				    left: 50%;
				    bottom: 50%;
				    background: #e81f27;
					transform-origin: center;
					transform: rotate(75deg) translate(38px, -30px);
				}
			}

			&.marker-20 {
				left: 50%;
				bottom: 77%;
				width: 25px;

				&:after {
					content: "";
				    display: block;
				    width: 1.5px;
				    height: 160px;
				    position: absolute;
				    left: 50%;
				    bottom: 50%;
				    background: #e81f27;
					transform-origin: center;
					transform: rotate(155deg) translate(31px, -151px);
				}
			}

			&.marker-21 {
				left: 57%;
				bottom: 73%;
				width: 25px;

				&:after {
					content: "";
					display: block;
					width: 1.5px;
					height: 130px;
					position: absolute;
					left: 50%;
					bottom: 50%;
					background: #e81f27;
					transform-origin: center;
					transform: rotate(82deg) translate(61px, -56px);
				}
			}

			&.marker-22 {
				left: 66%;
				bottom: 77%;
				width: 25px;
			}

			&.marker-23 {
				left: 71%;
				bottom: 76%;
				width: 25px;
			}

			&.marker-24 {
				left: 76%;
				bottom: 73%;
				width: 25px;

				&:after {
					content: "";
				    display: block;
				    width: 1.5px;
				    height: 210px;
				    position: absolute;
				    left: 50%;
				    bottom: 50%;
				    background: #e81f27;
					transform-origin: center;
					transform: rotate(56deg) translate(84px, 163px);
				}
			}
		}
	}

	@media screen and (max-width: 1600px) {
		.sleepingarea {
			top: calc(50% - 315px);
			left: calc(50% - 395px);
			width: 870px;
			height: 635px;
		}

		.sleepingarea .marker.marker-3:after {
			width: 96px;
			transform: rotate(21deg) translate(1px, 13px);
		}

		.sleepingarea .marker.marker-14:after {
			height: 100px;
			transform: rotate(120deg) translate(42px, -80px);
		}

		.sleepingarea .marker.marker-2:before {
			height: 140px;
		}

		.sleepingarea .marker.marker-1:after {
			height: 120px;
		}

		.sleepingarea .marker.marker-2:after {
			height: 110px;
			transform: rotate(41deg) translate(30px, -21px);
		}

		.sleepingarea .marker.marker-7:before {
			height: 120px;
			transform: rotate(57deg) translate(43px, 94px);
		}

		.sleepingarea .marker.marker-4:before {
			height: 150px;
			transform: rotate(97deg) translate(67px, -83px);
		}

		.sleepingarea .marker.marker-4:after {
			height: 90px;
			transform: rotate(65deg) translate(34px, -30px);
		}

		.sleepingarea .marker.marker-16:after {
			height: 90px;
			transform: rotate(-11deg) translate(-8px, 94px);
		}

		.sleepingarea .marker.marker-17:after {
			height: 75px;
			transform: rotate(-61deg) translate(-30px, 58px);
		}

		.sleepingarea .marker.marker-13:after {
			height: 120px;
			transform: rotate(51deg) translate(45px, -31px);
		}

		.sleepingarea .marker.marker-24:after {
			height: 190px;
			transform: rotate(56deg) translate(75px, 152px);
		}

		.sleepingarea .marker.marker-6:after {
			height: 190px;
			transform: rotate(76deg) translate(88px, -71px);
		}

		.sleepingarea .marker.marker-10:before {
			transform: rotate(181deg) translate(4px, -56px);
			height: 60px;
		}
		.sleepingarea .marker.marker-10:after {
			height: 90px;
			transform: rotate(95deg) translate(42px, -46px);
		}

		.sleepingarea .marker.marker-8:after {
			height: 112px;
			transform: rotate(93deg) translate(46px, 58px);
		}

		.sleepingarea .marker.marker-11:before {
			height: 140px;
			transform: rotate(36deg) translate(38px, -18px);
		}

		.sleepingarea .marker.marker-20:after {
			height: 150px;
			transform: rotate(155deg) translate(29px, -139px);
		}
	}

	@media screen and (max-width: 991px) {
		.sleepingarea {
		    top: calc(50% - 240px);
		    left: calc(50% - 305px);
		    width: 690px;
		    height: 510px;
		}

		.sleepingarea .marker.marker-1 {
		    width: 80px;
		}

		.sleepingarea .marker.marker-2 {
		    width: 70px;
		}

		.sleepingarea .marker.marker-3 {
		    width: 55px;
		}

		.sleepingarea .marker.marker-4 {
		    width: 45px;
		}

		.sleepingarea .marker.marker-5,
		.sleepingarea .marker.marker-6 {
		    width: 30px;
		}

		.sleepingarea .marker.marker-7 {
		    width: 60px;
		}

		.sleepingarea .marker.marker-8 {
		    width: 70px;
		}

		.sleepingarea .marker.marker-9 {
		    width: 55px;
		}

		.sleepingarea .marker.marker-10,
		.sleepingarea .marker.marker-11 {
		    width: 45px;
		}

		.sleepingarea .marker.marker-12,
		.sleepingarea .marker.marker-13 {
		    width: 35px;
		}

		.sleepingarea .marker.marker-14,
		.sleepingarea .marker.marker-15 {
		    width: 25px;
		}

		.sleepingarea .marker.marker-16,
		.sleepingarea .marker.marker-17,
		.sleepingarea .marker.marker-18,
		.sleepingarea .marker.marker-19,
		.sleepingarea .marker.marker-20,
		.sleepingarea .marker.marker-21,
		.sleepingarea .marker.marker-22,
		.sleepingarea .marker.marker-23,
		.sleepingarea .marker.marker-24 {
		    width: 20px;
		}

		.sleepingarea .marker.marker-1:before {
			width: 130px;
		}
		.sleepingarea .marker.marker-1:after {
			height: 90px;
			transform: rotate(-43deg) translate(-26px, -23px);
		}

		.sleepingarea .marker.marker-2:before {
		    height: 110px;
		}
		.sleepingarea .marker.marker-2:after {
		    height: 80px;
		    transform: rotate(41deg) translate(20px, -18px);
		}

		.sleepingarea .marker.marker-3:after {
		    width: 80px;
		    transform: rotate(21deg) translate(-3px, 10px);
		}

		.sleepingarea .marker.marker-4:before {
		    height: 120px;
		    transform: rotate(97deg) translate(52px, -67px);
		}
		.sleepingarea .marker.marker-4:after {
		    height: 70px;
		    transform: rotate(65deg) translate(26px, -24px);
		}

		.sleepingarea .marker.marker-5:before {
			height: 160px;
			transform: rotate(135deg) translate(59px, -141px);
		}
		.sleepingarea .marker.marker-5:after {
			height: 90px;
			transform: rotate(77deg) translate(42px, -41px);
		}

		.sleepingarea .marker.marker-6:before {
			height: 150px;
			transform: rotate(59deg) translate(58px, -43px);
		}
		.sleepingarea .marker.marker-6:after {
		    height: 150px;
		    transform: rotate(76deg) translate(69px, -63px);
		}

		.sleepingarea .marker.marker-7:before {
		    height: 100px;
		    transform: rotate(57deg) translate(37px, 76px);
		}
		.sleepingarea .marker.marker-7:after {
			height: 160px;
			transform: rotate(80deg) translate(74px, -65px);
		}

		.sleepingarea .marker.marker-8:after {
		    height: 90px;
		    transform: rotate(93deg) translate(37px, 44px);
		}

		.sleepingarea .marker.marker-10:before {
		    transform: rotate(181deg) translate(1px, -44px);
		    height: 50px;
		}
		.sleepingarea .marker.marker-10:after {
		    height: 70px;
		    transform: rotate(95deg) translate(30px, -37px);
		}

		.sleepingarea .marker.marker-11:before {
		    height: 110px;
		    transform: rotate(36deg) translate(29px, -14px);
		}
		.sleepingarea .marker.marker-11:after {
			height: 70px;
			transform: rotate(63deg) translate(29px, -29px);
		}

		.sleepingarea .marker.marker-13:after {
		    height: 90px;
		    transform: rotate(51deg) translate(33px, -24px);
		}

		.sleepingarea .marker.marker-14:after {
		    height: 90px;
		    transform: rotate(120deg) translate(37px, -65px);
		}

		.sleepingarea .marker.marker-15:after {
		    height: 60px;
			transform: rotate(51deg) translate(19px, -17px);
		}

		.sleepingarea .marker.marker-16:after {
		    height: 80px;
		    transform: rotate(-11deg) translate(-7px, 80px);
		}

		.sleepingarea .marker.marker-17:after {
		    height: 60px;
		    transform: rotate(-61deg) translate(-25px, 45px);
		}

		.sleepingarea .marker.marker-18:after {
			height: 65px;
			transform: rotate(50deg) translate(23px, 52px);
		}

		.sleepingarea .marker.marker-19:after {
			height: 55px;
			transform: rotate(75deg) translate(25px, -24px);
		}

		.sleepingarea .marker.marker-20:after {
		    height: 110px;
		    transform: rotate(155deg) translate(25px, -108px);
		}

		.sleepingarea .marker.marker-21:after {
			height: 90px;
			transform: rotate(82deg) translate(44px, -42px);
		}

		.sleepingarea .marker.marker-24:after {
		    height: 150px;
		    transform: rotate(56deg) translate(59px, 122px);
		}
	}

	@media screen and (max-width: 650px) {
		.sleepingarea {
		    top: calc(50% - 170px);
		    left: calc(50% - 232px);
		    width: 462px;
		    height: 329px;
		}

		.sleepingarea .marker.marker-1 {
		    width: 55px;
		}

		.sleepingarea .marker.marker-2 {
		    width: 45px;
		}

		.sleepingarea .marker.marker-3 {
		    width: 35px;
		}

		.sleepingarea .marker.marker-4 {
		    width: 30px;
		}

		.sleepingarea .marker.marker-5,
		.sleepingarea .marker.marker-6 {
		    width: 25px;
		}

		.sleepingarea .marker.marker-7,
		.sleepingarea .marker.marker-8,
		.sleepingarea .marker.marker-9 {
		    width: 40px;
		}

		.sleepingarea .marker.marker-10,
		.sleepingarea .marker.marker-11 {
		    width: 30px;
		}

		.sleepingarea .marker.marker-12,
		.sleepingarea .marker.marker-13,
		.sleepingarea .marker.marker-14,
		.sleepingarea .marker.marker-15,
		.sleepingarea .marker.marker-16,
		.sleepingarea .marker.marker-17,
		.sleepingarea .marker.marker-18,
		.sleepingarea .marker.marker-19,
		.sleepingarea .marker.marker-20,
		.sleepingarea .marker.marker-21,
		.sleepingarea .marker.marker-22,
		.sleepingarea .marker.marker-23,
		.sleepingarea .marker.marker-24 {
		    width: 25px;
		}

		.sleepingarea .marker.marker-1:before {
		    width: 70px;
		    height: 1.3px;
		    transform: rotate(0deg) translate(-1px, -4px);
		}
		.sleepingarea .marker.marker-1:after {
		    height: 50px;
		    width: 1.3px;
		    transform: rotate(-43deg) translate(-14px, -23px);
		}

		.sleepingarea .marker.marker-2:before {
		    height: 70px;
		    width: 1.3px;
		}
		.sleepingarea .marker.marker-2:after {
		    height: 60px;
		    width: 1.3px;
		    transform: rotate(41deg) translate(16px, -18px);
		}

		.sleepingarea .marker.marker-3:after {
		    width: 50px;
		    height: 1.3px;
		    transform: rotate(21deg) translate(0px, 6px);
		}

		.sleepingarea .marker.marker-4:before {
		    height: 70px;
		    width: 1.3px;
		    transform: rotate(97deg) translate(30px, -45px);
		}
		.sleepingarea .marker.marker-4:after {
		    height: 50px;
		    width: 1.3px;
		    transform: rotate(65deg) translate(19px, -20px);
		}

		.sleepingarea .marker.marker-5:before {
		    height: 110px;
		    width: 1.3px;
		    transform: rotate(135deg) translate(41px, -94px);
		}
		.sleepingarea .marker.marker-5:after {
		    height: 70px;
		    width: 1.3px;
		    transform: rotate(77deg) translate(31px, -29px);
		}

		.sleepingarea .marker.marker-6:before {
		    height: 100px;
		    width: 1.3px;
		    transform: rotate(59deg) translate(41px, -25px);
		}
		.sleepingarea .marker.marker-6:after {
		    height: 90px;
		    width: 1.3px;
		    transform: rotate(76deg) translate(43px, -34px);
		}

		.sleepingarea .marker.marker-7:before {
		    height: 70px;
		    width: 1.3px;
		    transform: rotate(57deg) translate(24px, 51px);
		}
		.sleepingarea .marker.marker-7:after {
		    height: 100px;
		    width: 1.3px;
		    transform: rotate(80deg) translate(44px, -41px);
		}

		.sleepingarea .marker.marker-8:after {
		    height: 50px;
		    width: 1.3px;
		    transform: rotate(93deg) translate(20px, 30px);
		}

		.sleepingarea .marker.marker-10:before {
		    transform: rotate(181deg) translate(0px, -24px);
		    height: 30px;
		    width: 1.3px;
		}
		.sleepingarea .marker.marker-10:after {
		    height: 40px;
		    width: 1.3px;
		    transform: rotate(95deg) translate(17px, -27px);
		}

		.sleepingarea .marker.marker-11:before {
		    height: 70px;
		    width: 1.3px;
		    transform: rotate(36deg) translate(20px, -15px);
		}
		.sleepingarea .marker.marker-11:after {
		    height: 50px;
		    width: 1.3px;
		    transform: rotate(63deg) translate(20px, -19px);
		}

		.sleepingarea .marker.marker-13:after {
		    height: 70px;
		    width: 1.3px;
		    transform: rotate(51deg) translate(25px, -20px);
		}

		.sleepingarea .marker.marker-14:after {
		    height: 60px;
		    width: 1.3px;
		    transform: rotate(120deg) translate(25px, -43px);
		}

		.sleepingarea .marker.marker-15:after {
		    height: 40px;
		    width: 1.3px;
		    transform: rotate(51deg) translate(14px, -12px);
		}

		.sleepingarea .marker.marker-16:after {
		    height: 50px;
		    width: 1.3px;
		    transform: rotate(-11deg) translate(-5px, 53px);
		}

		.sleepingarea .marker.marker-17:after {
		    height: 40px;
		    transform: rotate(-61deg) translate(-16px, 30px);
		    width: 1.3px;
		}

		.sleepingarea .marker.marker-18:after {
		    height: 40px;
		    width: 1.3px;
		    transform: rotate(50deg) translate(13px, 35px);
		}

		.sleepingarea .marker.marker-19:after {
		    height: 40px;
		    width: 1.3px;
		    transform: rotate(75deg) translate(18px, -19px);
		}

		.sleepingarea .marker.marker-20:after {
		    height: 80px;
		    width: 1.3px;
		    transform: rotate(155deg) translate(20px, -73px);
		}

		.sleepingarea .marker.marker-21:after {
		    height: 60px;
		    width: 1.3px;
		    transform: rotate(82deg) translate(30px, -28px);
		}

		.sleepingarea .marker.marker-24:after {
		    height: 110px;
		    transform: rotate(56deg) translate(44px, 84px);
		}
	}
</style>
